import { createSlice } from '@reduxjs/toolkit';

const salesSlice = createSlice({
  name: 'sales',
  initialState: {
    transactions: [],
  },
  reducers: {
    setTransactions(state, action) {
      state.transactions = action.payload;
    },
    addTransaction(state, action) {
      state.transactions.unshift(action.payload);
    },
    clearTransactions(state) {
      state.transactions = [];
    },
  },
});

export const { setTransactions, addTransaction, clearTransactions } = salesSlice.actions;
export default salesSlice.reducer;
